import { types } from 'mobx-state-tree';

export enum ProgressStateModel { NotInitialized = 'notInitialized', Loading = 'loading', Success = 'success', Failed = 'failed' };

export const ProgressStateModelForStore = types.enumeration('ProgressStateModelForStore', [ProgressStateModel.NotInitialized, ProgressStateModel.Loading, ProgressStateModel.Success, ProgressStateModel.Failed]);

export enum TransitionStateModelType { InProgress = 'inProgress', Ended = 'ended' };

export const TransitionStateModelForStore = types.enumeration('TransitionStateModelForStore', [TransitionStateModelType.InProgress, TransitionStateModelType.Ended]);
